var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { utilities } from "../utilities/utilities";
var Element = /** @class */ (function () {
    function Element(args) {
        var _this = this;
        this.version = "element.1.0.0";
        this.events = {};
        this.compose = function () {
            //will work whether content is a string, or html, ideally will always be written as html though
            _this.element = utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", "\n        "], ["\n            ", "\n        "])), _this.composer.content);
        };
        this.setEvents = function () {
            if (!_this.events)
                return;
            for (var _i = 0, _a = Object.entries(_this.events); _i < _a.length; _i++) {
                var _b = _a[_i], eventName = _b[0], handler = _b[1];
                _this.element.addEventListener(eventName, handler);
            }
        };
        this.render = function () {
            var _a;
            _this.compose();
            _this.setEvents();
            (_a = _this === null || _this === void 0 ? void 0 : _this.init) === null || _a === void 0 ? void 0 : _a.call(_this, _this);
            return _this.element;
        };
        this.composer = args.composer;
        this.events = args.events;
        if (args.init)
            this.init = args.init;
    }
    return Element;
}());
export { Element };
var templateObject_1;
